/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_Err_EmptyInputs */

const vi_sales_return_err_empty = /** @type {(inputs: Sales_Return_Err_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập số lượng trả cho ít nhất một dòng hàng`)
};

/**

* @param {Sales_Return_Err_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_err_empty = /** @type {((inputs?: Sales_Return_Err_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Err_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_err_empty(inputs)
});